import React, { useEffect, useState } from "react"
import { formatDateDataGrid } from "src/utils/format-date"
import PropTypes from 'prop-types'
import dayjs from "dayjs"
import { DATE_FORMAT, DATE_TIME_FORMAT_SHOW } from "src/utils/constants"
import DatalakeService from "src/services/datalake-service"
import ParameterPaginationTable from "src/components/table/parameter-pagination-table"

const ParameterCBondsNewFlowTable = (props) => {
    const dataLakeService = new DatalakeService()
    const [data, setData] = useState([])
    const [pagination, setPagination] = useState({ count: 0, next: null, previous: null })

    useEffect(() => {
        loadData()
    }, [])

    const loadData = () => {
        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint).then((response) => {
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj, index) => ({ ...obj, id: index }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        }).catch((err) => {
            props.callbackError(err)
        }).finally(() => {
            props.loading(false)
        })
    }

    const createRow = async () => {
        const body = {
            "IDEmissao": null,
            "DataInicio": dayjs().format(DATE_FORMAT),
            "DataReferencia": dayjs().format(DATE_FORMAT),
            "DataRegistro": dayjs().format(DATE_FORMAT),
            "NumeroCupom": null,
            "TaxaCupom": null,
            "DataTaxaCupom": dayjs().format(DATE_FORMAT),
            "ValorCupom": null,
            "DataPagamentoReal": dayjs().format(DATE_FORMAT),
            "Resgate": null,
            "FatorPool": null,
            "DataInicioNaoNegociacao": dayjs().format(DATE_FORMAT),
            "DataFimNaoNegociacao": dayjs().format(DATE_FORMAT),
            "NaoParar": null,
            "TaxaFlutuante": null,
            "DiasEntreCupons": null,
            "CupomPik": null,
            "PercentualResgate": null,
            "IDStatusEmissao": null,
            "IDTipoEmissao": null,
            "MultiploIntegralEmissao": null,
            "PrecoNominalEmissao": null,
            "NominalEurobondsEmissao": null,
            "UnidadeMinimaNegociavelEmissao": null,
            "TitulosHipotecariosEmissao": null,
            "SecuritizacaoEmissao": null,
            "TipoTituloEmissao": null,
            "DataInicioColocacaoEmissao": dayjs().format(DATE_FORMAT),
            "DataFimColocacaoEmissao": dayjs().format(DATE_FORMAT),
            "DataVencimentoEmissao": dayjs().format(DATE_FORMAT),
            "ISIN": null,
            "ISIN144a": null,
            "IDEmitenteEmissao": null,
            "IDPaisEmitente": null,
            "IDRegiaoPaisEmitente": null,
            "IDSubregiaoPaisEmitente": null,
            "IDFilialEmitente": null,
            "IDTipoEmitente": null,
            "IDMoedaEmissao": null,
            "MostrarRu": null,
            "MostrarEm": null,
            "MostrarPl": null,
            "MostrarUa": null,
            "MostrarIb": null,
            "ValorCupomMultiploIntegral": null,
            "ValorResgateMultiploIntegral": null,
            "ValorCupomNominalEurobonds": null,
            "ValorResgateNominalEurobonds": null,
            "ValorCupomUnidadeMinimaNegociavel": null,
            "ValorResgateUnidadeMinimaNegociavel": null,
            "NaoAgendado": null,
            "MaisInformacoesRus": null,
            "MaisInformacoesEng": null,
            "MaisInformacoesPol": null,
            "MaisInformacoesIta": null,
            "created_at": dayjs().format(DATE_TIME_FORMAT_SHOW),
            "updated_at": dayjs().format(DATE_TIME_FORMAT_SHOW),
        }

        console.log("DataReferencia:", body.DataReferencia)

        props.loading(true)
        return dataLakeService.createTableEndpoint(props.endpoint, body).then(() => {
            props.loading(false)
            loadData(0, 25)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const updateRow = async (newRow) => {
        const {
            ID,
            IDEmissao,
            DataInicio,
            DataReferencia,
            DataRegistro,
            NumeroCupom,
            TaxaCupom,
            DataTaxaCupom,
            ValorCupom,
            DataPagamentoReal,
            Resgate,
            FatorPool,
            DataInicioNaoNegociacao,
            DataFimNaoNegociacao,
            NaoParar,
            TaxaFlutuante,
            DiasEntreCupons,
            CupomPik,
            PercentualResgate,
            IDStatusEmissao,
            IDTipoEmissao,
            MultiploIntegralEmissao,
            PrecoNominalEmissao,
            NominalEurobondsEmissao,
            UnidadeMinimaNegociavelEmissao,
            TitulosHipotecariosEmissao,
            SecuritizacaoEmissao,
            TipoTituloEmissao,
            DataInicioColocacaoEmissao,
            DataFimColocacaoEmissao,
            DataVencimentoEmissao,
            ISIN,
            ISIN144a,
            IDEmitenteEmissao,
            IDPaisEmitente,
            IDRegiaoPaisEmitente,
            IDSubregiaoPaisEmitente,
            IDFilialEmitente,
            IDTipoEmitente,
            IDMoedaEmissao,
            MostrarRu,
            MostrarEm,
            MostrarPl,
            MostrarUa,
            MostrarIb,
            ValorCupomMultiploIntegral,
            ValorResgateMultiploIntegral,
            ValorCupomNominalEurobonds,
            ValorResgateNominalEurobonds,
            ValorCupomUnidadeMinimaNegociavel,
            ValorResgateUnidadeMinimaNegociavel,
            NaoAgendado,
            MaisInformacoesRus,
            MaisInformacoesEng,
            MaisInformacoesPol,
            MaisInformacoesIta,
            created_at,
            updated_at
        } = newRow

        const body = {
            "IDEmissao": IDEmissao,
            "DataInicio": DataInicio,
            "DataReferencia": DataReferencia,
            "DataRegistro": DataRegistro,
            "NumeroCupom": NumeroCupom,
            "TaxaCupom": TaxaCupom,
            "DataTaxaCupom": DataTaxaCupom,
            "ValorCupom": ValorCupom,
            "DataPagamentoReal": DataPagamentoReal,
            "Resgate": Resgate,
            "FatorPool": FatorPool,
            "DataInicioNaoNegociacao": DataInicioNaoNegociacao,
            "DataFimNaoNegociacao": DataFimNaoNegociacao,
            "NaoParar": NaoParar,
            "TaxaFlutuante": TaxaFlutuante,
            "DiasEntreCupons": DiasEntreCupons,
            "CupomPik": CupomPik,
            "PercentualResgate": PercentualResgate,
            "IDStatusEmissao": IDStatusEmissao,
            "IDTipoEmissao": IDTipoEmissao,
            "MultiploIntegralEmissao": MultiploIntegralEmissao,
            "PrecoNominalEmissao": PrecoNominalEmissao,
            "NominalEurobondsEmissao": NominalEurobondsEmissao,
            "UnidadeMinimaNegociavelEmissao": UnidadeMinimaNegociavelEmissao,
            "TitulosHipotecariosEmissao": TitulosHipotecariosEmissao,
            "SecuritizacaoEmissao": SecuritizacaoEmissao,
            "TipoTituloEmissao": TipoTituloEmissao,
            "DataInicioColocacaoEmissao": DataInicioColocacaoEmissao,
            "DataFimColocacaoEmissao": DataFimColocacaoEmissao,
            "DataVencimentoEmissao": DataVencimentoEmissao,
            "ISIN": ISIN,
            "ISIN144a": ISIN144a,
            "IDEmitenteEmissao": IDEmitenteEmissao,
            "IDPaisEmitente": IDPaisEmitente,
            "IDRegiaoPaisEmitente": IDRegiaoPaisEmitente,
            "IDSubregiaoPaisEmitente": IDSubregiaoPaisEmitente,
            "IDFilialEmitente": IDFilialEmitente,
            "IDTipoEmitente": IDTipoEmitente,
            "IDMoedaEmissao": IDMoedaEmissao,
            "MostrarRu": MostrarRu,
            "MostrarEm": MostrarEm,
            "MostrarPl": MostrarPl,
            "MostrarUa": MostrarUa,
            "MostrarIb": MostrarIb,
            "ValorCupomMultiploIntegral": ValorCupomMultiploIntegral,
            "ValorResgateMultiploIntegral": ValorResgateMultiploIntegral,
            "ValorCupomNominalEurobonds": ValorCupomNominalEurobonds,
            "ValorResgateNominalEurobonds": ValorResgateNominalEurobonds,
            "ValorCupomUnidadeMinimaNegociavel": ValorCupomUnidadeMinimaNegociavel,
            "ValorResgateUnidadeMinimaNegociavel": ValorResgateUnidadeMinimaNegociavel,
            "NaoAgendado": NaoAgendado,
            "MaisInformacoesRus": MaisInformacoesRus,
            "MaisInformacoesEng": MaisInformacoesEng,
            "MaisInformacoesPol": MaisInformacoesPol,
            "MaisInformacoesIta": MaisInformacoesIta,
            "created_at": created_at,
            "updated_at": updated_at
        }

        props.loading(true)
        return dataLakeService.updateTableEndpoint(props.endpoint, ID, body).then(() => {
            props.loading(false)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const deleteRow = async (row) => {
        props.loading(true)
        const { ID } = row
        return dataLakeService.deleteTableEndpoint(props.endpoint, ID).then(() => {
            props.loading(false)
            const listRemoved = data.filter((item) => item.ID !== ID)
            setData(listRemoved)
        }).catch((err) => {
            props.loading(false)
            throw err
        })
    }

    const onFilter = async (filterList, limit, offset) => {
        const query = filterList.map(obj => `${encodeURIComponent(obj.field)}=${encodeURIComponent(obj.value)}`).join('&')

        props.loading(true)
        dataLakeService.loadPaginationEndpoint(props.endpoint, query, limit, offset).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, next, previous } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))
            setPagination({ count: count, next: next, previous: previous })
            setData(list)
        })
    }

    const changePage = async (endpoint) => {
        props.loading(true)
        dataLakeService.paginate(endpoint).then((response) => {
            props.loading(false)
            const { body } = response
            const { results, count, previous, next } = body
            const list = results.map((obj) => ({ ...obj, id: obj.ID }))

            setPagination({ count: count, next: next, previous: previous })
            setData([])
            setData(list)
        })
    }

    const columns = [
        {
            field: 'ID',
            headerName: '#',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 80,
        },
        {
            field: 'IDEmissao',
            headerName: 'IDEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DataInicio',
            headerName: 'DataInicio',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'DataReferencia',
            headerName: 'DataReferencia',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'DataRegistro',
            headerName: 'DataRegistro',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'NumeroCupom',
            headerName: 'NumeroCupom',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TaxaCupom',
            headerName: 'TaxaCupom',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DataTaxaCupom',
            headerName: 'DataTaxaCupom',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'ValorCupom',
            headerName: 'ValorCupom',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DataPagamentoReal',
            headerName: 'DataPagamentoReal',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'Resgate',
            headerName: 'Resgate',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'FatorPool',
            headerName: 'FatorPool',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'DataInicioNaoNegociacao',
            headerName: 'DataInicioNaoNegociacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            },
        },
        {
            field: 'DataFimNaoNegociacao',
            headerName: 'DataFimNaoNegociacao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            },
        },
        {
            field: 'NaoParar',
            headerName: 'NaoParar',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TaxaFlutuante',
            headerName: 'TaxaFlutuante',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DiasEntreCupons',
            headerName: 'DiasEntreCupons',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'CupomPik',
            headerName: 'CupomPik',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PercentualResgate',
            headerName: 'PercentualResgate',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDStatusEmissao',
            headerName: 'IDStatusEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDTipoEmissao',
            headerName: 'IDTipoEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MultiploIntegralEmissao',
            headerName: 'MultiploIntegralEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'PrecoNominalEmissao',
            headerName: 'PrecoNominalEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NominalEurobondsEmissao',
            headerName: 'NominalEurobondsEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'UnidadeMinimaNegociavelEmissao',
            headerName: 'UnidadeMinimaNegociavelEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TitulosHipotecariosEmissao',
            headerName: 'TitulosHipotecariosEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'SecuritizacaoEmissao',
            headerName: 'SecuritizacaoEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'TipoTituloEmissao',
            headerName: 'TipoTituloEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'DataInicioColocacaoEmissao',
            headerName: 'DataInicioColocacaoEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'DataFimColocacaoEmissao',
            headerName: 'DataFimColocacaoEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'DataVencimentoEmissao',
            headerName: 'DataVencimentoEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            typeComponent: 'date',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => {
                if (!value) return ''
                return dayjs.utc(value).format(DATE_FORMAT)
            }
        },
        {
            field: 'ISIN',
            headerName: 'ISIN',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'ISIN144a',
            headerName: 'ISIN144a',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'IDEmitenteEmissao',
            headerName: 'IDEmitenteEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDPaisEmitente',
            headerName: 'IDPaisEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDRegiaoPaisEmitente',
            headerName: 'IDRegiaoPaisEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDSubregiaoPaisEmitente',
            headerName: 'IDSubregiaoPaisEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDFilialEmitente',
            headerName: 'IDFilialEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDTipoEmitente',
            headerName: 'IDTipoEmitente',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'IDMoedaEmissao',
            headerName: 'IDMoedaEmissao',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MostrarRu',
            headerName: 'MostrarRu',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MostrarEm',
            headerName: 'MostrarEm',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MostrarPl',
            headerName: 'MostrarPl',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MostrarUa',
            headerName: 'MostrarUa',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MostrarIb',
            headerName: 'MostrarIb',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'ValorCupomMultiploIntegral',
            headerName: 'ValorCupomMultiploIntegral',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'ValorResgateMultiploIntegral',
            headerName: 'ValorResgateMultiploIntegral',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'ValorCupomNominalEurobonds',
            headerName: 'ValorCupomNominalEurobonds',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'ValorResgateNominalEurobonds',
            headerName: 'ValorResgateNominalEurobonds',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'ValorCupomUnidadeMinimaNegociavel',
            headerName: 'ValorCupomUnidadeMinimaNegociavel',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'ValorResgateUnidadeMinimaNegociavel',
            headerName: 'ValorResgateUnidadeMinimaNegociavel',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'NaoAgendado',
            headerName: 'NaoAgendado',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150,
            type: 'number'
        },
        {
            field: 'MaisInformacoesRus',
            headerName: 'MaisInformacoesRus',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'MaisInformacoesEng',
            headerName: 'MaisInformacoesEng',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'MaisInformacoesPol',
            headerName: 'MaisInformacoesPol',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'MaisInformacoesIta',
            headerName: 'MaisInformacoesIta',
            disableColumnMenu: true,
            flex: true,
            minWidth: 150
        },
        {
            field: 'created_at',
            headerName: 'created_at',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150,
            type: 'dateTime',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_TIME_FORMAT_SHOW) : '',
        },
        {
            field: 'updated_at',
            headerName: 'updated_at',
            disableColumnMenu: true,
            disableFilter: true,
            flex: true,
            minWidth: 150,
            type: 'dateTime',
            valueGetter: ({ value }) => (value ? new Date(value) : null),
            valueFormatter: ({ value }) => value instanceof Date && !isNaN(value) ? dayjs(value).format(DATE_TIME_FORMAT_SHOW) : '',
        },
        {
            field: 'CriadoEm',
            headerName: 'Data de Criação',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        },
        {
            field: 'AtualizadoEm',
            headerName: 'Data de Atualização',
            flex: true,
            minWidth: 150,
            disableColumnMenu: true,
            disableFilter: true,
            renderCell: (params) => formatDateDataGrid(params)
        }
    ]

    return (
        <div>
            <ParameterPaginationTable
                columns={columns}
                data={data}
                setData={setData}
                createRow={createRow}
                deleteRow={deleteRow}
                updateRow={updateRow}
                filterFunction={onFilter}
                pagination={pagination}
                onChangePage={changePage}
                customFilter={true} />
        </div>
    )
}

ParameterCBondsNewFlowTable.propTypes = {
    loading: PropTypes.func,
    endpoint: PropTypes.string,
    callbackError: PropTypes.func
}

export default ParameterCBondsNewFlowTable